export const SCHEMA_TIME_SERIES = [
  {
    table_id: 'plug_output_time_series',
    col_id: 'plug_id',
    col_name: 'Plug ID #',
    col_desc: 'Plug ID #',
    col_unit: '-',
    ui_editable: false,
    ui_show: false,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'plug_name',
    col_name: 'Plug Name',
    col_desc: 'Plug Name',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 't',
    col_name: 'Time',
    col_desc: 'Time',
    col_unit: 'min',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'q',
    col_name: 'Flow rate',
    col_desc: 'Flow rate',
    col_unit: 'bpm',
    calc_unit: 'gpm',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'fluid_type',
    col_name: 'Current Pumping Fluid',
    col_desc: 'Current Pumping Fluid',
    col_unit: '-',
    ui_editable: false,
    ui_show: true,
    data_type: 'str',
    decimal: 0
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'dVol',
    col_name: 'Pumped Volume',
    col_desc: 'Pumped Volume',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'cum_vol',
    col_name: 'Cum Volume',
    col_desc: 'Cumulative Pumped Volume',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_cement_tub',
    col_name: 'Cement Length (Tubing)',
    col_desc: 'Length of Cement Fluid inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_cement_ann',
    col_name: 'Cement Length (Annulus)',
    col_desc: 'Length of Cement Fluid inside Annulus',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_cement_pipe',
    col_name: 'Cement Length (Pipe)',
    col_desc: 'Length of Cement Fluid inside Pipe',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_cement_st',
    col_name: 'Cement Length (Stinger)',
    col_desc: 'Length of Cement Fluid inside Stinger',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_spacer_lead_tub',
    col_name: 'Spacer Length (Tubing)',
    col_desc: 'Length of Spacer Fluid inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_spacer_lead_ann',
    col_name: 'Spacer Length (Annulus)',
    col_desc: 'Length of Spacer Fluid inside Annulus',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_spacer_lead_pipe',
    col_name: 'Spacer Length (Pipe)',
    col_desc: 'Length of Spacer Fluid inside Pipe',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_spacer_lead_st',
    col_name: 'Spacer Length (Stinger)',
    col_desc: 'Length of Spacer Fluid inside Stinger',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_spacer_tail_tub',
    col_name: 'Tail Spacer Length (Tubing)',
    col_desc: 'Length of Tail Spacer Fluid inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_spacer_tail_pipe',
    col_name: 'Tail Spacer Length (Pipe)',
    col_desc: 'Length of Tail Spacer Fluid inside Pipe',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_spacer_tail_st',
    col_name: 'Tail Spacer Length (Stinger)',
    col_desc: 'Length of Tail Spacer Fluid inside Stinger',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_displacement_tub',
    col_name: 'Displacement Length (Tubing)',
    col_desc: 'Length of Displacement Fluid inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_displacement_pipe',
    col_name: 'Displacement Length (Pipe)',
    col_desc: 'Length of Displacement Fluid inside Pipe',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_displacement_st',
    col_name: 'Displacement Length (Stinger)',
    col_desc: 'Length of Displacement Fluid inside Stinger',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_mud_tub',
    col_name: 'Mud Length (Tubing)',
    col_desc: 'Length of Mud Fluid inside Tubing',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_mud_ann',
    col_name: 'Mud Length (Annulus)',
    col_desc: 'Length of Mud Fluid inside Annulus',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_mud_pipe',
    col_name: 'Mud Length (Pipe)',
    col_desc: 'Length of Mud Fluid inside Pipe',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'l_mud_st',
    col_name: 'Mud Length (Stinger)',
    col_desc: 'Length of Mud Fluid inside Stinger',
    col_unit: 'ft',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'vol_spacer_lead_squeezed',
    col_name: 'Spacer Squeezed',
    col_desc: 'Squeeze only: cumulative lead spacer volume pushed through the perforations',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'vol_cement_squeezed',
    col_name: 'Cement Squeezed',
    col_desc: 'Squeeze only: cumulative cement volume pushed through the perforations',
    col_unit: 'bbl',
    calc_unit: 'gal',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'p_perf',
    col_name: 'Perforation Pressure',
    col_desc: 'Squeeze only: pressure outside the perforations ',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'dp_perf',
    col_name: 'Perforation Pressure Drop',
    col_desc: 'Squeeze only: orifice pressure drop of the fluid leaving the casing through the perforations',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'p_pump',
    col_name: 'Pump Pressure',
    col_desc: 'Required Surface Pump Pressure',
    col_unit: 'psi',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  },
  {
    table_id: 'plug_output_time_series',
    col_id: 'hp',
    col_name: 'Pump Power',
    col_desc: 'Require Surface Pump Power',
    col_unit: 'hp',
    ui_editable: false,
    ui_show: true,
    data_type: 'float',
    decimal: 2
  }
];

export default SCHEMA_TIME_SERIES;
